import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  initDataComponent,
  performRetrieveListRequest,
} from "../../../../actions/dataComponentActions";
import GLCodesSection from "./GLCodesSection";

const GLCodesSectionContainer = ({ values, clientId, isVendorPortal }) => {
  return (
    <GLCodesSection
      values={values}
      clientId={clientId}
      isVendorPortal={isVendorPortal}
    />
  );
};

GLCodesSectionContainer.propTypes = {
  initDataComponent: PropTypes.func.isRequired,
  performRetrieveListRequest: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
  values: PropTypes.shape({}),
  isVendorPortal: PropTypes.bool,
};

export default connect(null, { initDataComponent, performRetrieveListRequest })(
  GLCodesSectionContainer
);
